import { render } from "./GrupoList.vue?vue&type=template&id=4ec784c4&scoped=true"
import script from "./GrupoList.vue?vue&type=script&lang=js"
export * from "./GrupoList.vue?vue&type=script&lang=js"

import "./GrupoList.vue?vue&type=style&index=0&id=4ec784c4&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\fronted_sit_bolivia\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ec784c4"]])

export default __exports__